import type { GetHouseTypeExpectedConsumptionV1Data } from '@integration/api-client/metering';

export type UsageQuestionnaireRendering = {
  title: string;
  subtitle: string;
  residentsLabel: string;
  residentsDefaultOption: string;
  residentsOptions: {
    label: string;
    value: GetHouseTypeExpectedConsumptionV1Data['residents'];
  }[];
  residentsRequiredError: string;
  houseTypeLabel: string;
  houseTypeDefaultOption: string;
  houseTypeOptions: {
    label: string;
    value: GetHouseTypeExpectedConsumptionV1Data['houseType'];
  }[];
  houseTypeRequiredError: string;
  primaryButtonLabel: string;
};

export const UsageQuestionnaireRenderingDefaults: UsageQuestionnaireRendering =
  {
    title: 'Mijn verbruik inschatten',
    subtitle:
      'Beantwoord onderstaande vragen en we maken een inschatting van je jaarverbruik.',
    residentsLabel: 'Hoeveel personen wonen er op dit adres?',
    residentsDefaultOption: 'Maak een keuze',
    residentsOptions: [
      {
        label: '1 persoon',
        value: 1,
      },
      {
        label: '2 personen',
        value: 2,
      },
      {
        label: '3 personen',
        value: 3,
      },
      {
        label: '4 personen',
        value: 4,
      },
      {
        label: '5 personen',
        value: 5,
      },
      {
        label: '6 personen of meer',
        value: 6,
      },
    ],
    residentsRequiredError: 'Maak een keuze om door te gaan',
    houseTypeLabel: 'Om wat voor type woning gaat het?',
    houseTypeDefaultOption: 'Maak een keuze',
    houseTypeOptions: [
      {
        label: 'Flat of appartement',
        value: 'appartement',
      },
      {
        label: 'Hoekwoning',
        value: 'hoek',
      },
      {
        label: 'Rijtjeshuis',
        value: 'rijtje',
      },
      {
        label: 'Twee onder een kap',
        value: '2onder1kap',
      },
      {
        label: 'Vrijstaande woning',
        value: 'vrijstaand',
      },
    ],
    houseTypeRequiredError: 'Maak een keuze om door te gaan',
    primaryButtonLabel: 'Schat verbruik in',
  };
